import {
  ICorporationUnreadChatRoomMessage,
  UserTypes,
} from '@commenda/types/src/chat-room/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export type UseGetAllUnreadChatMessagesParams =
  | {
      userType: UserTypes.ACCOUNTANT;
      caFirmId: string;
    }
  | {
      userType: UserTypes.CLIENT;
      companyId: number;
    }
  | {
      userType: UserTypes.AGENT;
    };

/**
 *  By default, the API will return only 5 recent unread messages,
 *  In future, we can extend this to have a proper pagination.
 */
export function useGetAllUnreadChatMessages(
  params: UseGetAllUnreadChatMessagesParams
) {
  const searchParams = new URLSearchParams();

  searchParams.set('userType', params.userType);

  if (params.userType === UserTypes.ACCOUNTANT) {
    searchParams.set('caFirmId', params.caFirmId);
  } else if (params.userType === UserTypes.CLIENT) {
    searchParams.set('companyId', params.companyId.toString());
  }

  const url = `chatRoom/messages?${searchParams.toString()}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: ICorporationUnreadChatRoomMessage[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    url,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
